import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LearnitBaseDataApi from '../generated/api/LearnitBaseData';

export default (service: Servicelayer) => ({
  ...LearnitBaseDataApi(service),

  // Add custom calls here

});
